import React from 'react';
import { Message } from '../Message';
import styled from 'styled-components/macro';
import { AiOutlineStop, IoMdInformationCircleOutline } from 'react-icons/all';

interface Props {
  message: Message;
}

export const MessageInfo = ({ message }: Props) => (
  <StyledMessage
    className="bg-main text-white"
    dangerouslySetInnerHTML={{ __html: message.message }}
  />
);

export const MessageInfoLight = ({ message }: Props) => (
  <StyledMessage className="border-gray-800 text-blackflex flex items-center h-full">
    <IoMdInformationCircleOutline className="h-10 w-10 text-gray-800 mr-4" />
    <div dangerouslySetInnerHTML={{ __html: message.message }} />
  </StyledMessage>
);

// export const MessageError = ({ message }: Props) => (
//   <StyledMessage
//     className="text-red-dark "
//     dangerouslySetInnerHTML={{ __html: message.message }}
//   />
// );

export const MessageCancel = ({ message }: Props) => (
  <StyledMessage className="border-red-dark flex items-center h-full">
    <AiOutlineStop className="h-12 w-12 text-red-dark mr-4" />
    <div dangerouslySetInnerHTML={{ __html: message.message }} />
  </StyledMessage>
);

const StyledMessage = styled.div`
  border-color: ${p => p.theme.gray600};

  border-radius: 0.25rem;
  border-width: 1px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 0.25rem 0.5rem;
`;
